<template>
  <div class="error-page">
    <i :class="icon" />
    <div class="error-page-desc">
      {{ desc }}
    </div>
  </div>
</template>

<script>
const DEFAULT_DESC = {
  error: '系统繁忙，请稍后重试',
  404: '404'
};
const ICON = {
  error: 'el-icon-error',
  404: 'el-icon-question'
};

export default {
  props: {
    description: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => 'error'
    }
  },
  data() {
    return {
      err: null,
      loaded: false
    };
  },
  computed: {
    icon() {
      return ICON[this.type] || 'el-icon-error';
    },
    desc() {
      if (this.description) return this.description;
      return DEFAULT_DESC[this.type] || '系统繁忙，请稍后重试';
    }
  }
};
</script>

<style lang="less" scoped>
.error-page {
  height: 100%;
  width: 100%;
  text-align: center;
  margin-top: 200px;

  i {
    color: @brandColor;
    font-size: 60px;
  }

  .error-page-desc {
    margin-top: 60px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 24px;
    line-height: 1.8;
    text-align: center;
  }
}
</style>
